import { ControllerFontType, makeStyles } from '@bymason-private/controller-v1-theme-provider';
import { Text, ControllerAlert, Button } from '@bymason-private/legacy-pattern-components';
import { ControllerLogo } from '../signup/controller-logo';
import { useAuth } from '@bymason-private/auth-provider';

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 5,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 320,
    marginTop: 72,
    marginBottom: 40,
    flexBasis: 200,
    transition: 'all 0.3s ease-in-out',
    padding: '48px 20px',
    '& > *': {
      width: '100%',
    },
    '& > *:not(:last-child)': {
      marginBottom: 16,
    },
    [theme.breakpoints.down('sm')]: {
      margin: '10%',
    },
  },
  button: {
    color: 'white',
    marginBottom: 16,
    '&:hover': {
      color: 'white',
      backgroundColor: 'transparent',
    },
  },
  section: {
    background:
      'url("https://bymason.com/wp-content/uploads/2020/07/device_mgmt_hero-1.png") center center / cover no-repeat fixed',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%',
  },
}));

export default function ValidateMessage() {
  const classes = useStyles();
  const { logout = () => null } = useAuth();
  const handleButtonClick = () => {
    logout();
  };

  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <ControllerLogo />

        <ControllerAlert severity='error' variant='outlined'>
          Pending email verification
        </ControllerAlert>
        <Text variant={ControllerFontType.Body400R} component='div' textAlign='center'>
          <span>Please check your email for an activation link to complete the signup process</span>
        </Text>
      </div>
      <Button className={classes.button} onClick={handleButtonClick} disableTouchRipple>
        Go to login
      </Button>
    </section>
  );
}
